export default __webpack_public_path__ + "static/media/SAL7.adc5bd08.jpg";